export const FILE_STATUS = {
    ready: 'ready',
    progress: 'progress',
    error: 'error',
    success: 'success',
};
